import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import CustomerHeader from "../../components/CustomerHeader";
import { Button } from "../../components/ui/button";
import { Sparkles, ChevronRight, Loader2 } from "lucide-react";

const LABEL_COLOR = { "Completata": "#00E676", "In corso": "#22D3EE", "In preparazione": "#A78BFA", "Confermata": "#60A5FA", "In attesa": "#F59E0B", "Annullata": "#EF4444" };

export default function MyExperiences() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/experiences/orders").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white">
      <CustomerHeader />
      <main className="max-w-2xl mx-auto px-4 py-6" data-testid="my-experiences-page">
        <div className="flex items-center gap-2 mb-5">
          <Sparkles className="h-6 w-6 text-[#7DF9FF]" />
          <h1 className="font-display font-black text-2xl tracking-tight">Le mie Esperienze</h1>
        </div>

        {!items && <div className="text-zinc-500 py-10 text-center"><Loader2 className="h-4 w-4 animate-spin inline" /> Caricamento…</div>}

        {items && items.length === 0 && (
          <div className="text-center border border-dashed border-white/10 rounded-2xl py-12 px-4" data-testid="my-experiences-empty">
            <p className="text-zinc-400 mb-4">Non hai ancora creato un'esperienza.</p>
            <Button onClick={() => navigate("/esperienze")} className="bg-gradient-to-r from-[#7DF9FF] to-[#00E676] text-black rounded-full" data-testid="create-first-experience">
              <Sparkles className="h-4 w-4 mr-1" /> Crea la tua prima esperienza
            </Button>
          </div>
        )}

        <div className="space-y-4">
          {(items || []).map((e) => (
            <button key={e.id} onClick={() => navigate(`/app/esperienze/${e.id}`)} data-testid={`experience-card-${e.id}`}
              className="w-full text-left rounded-2xl overflow-hidden border border-white/10 bg-[#141417] hover:border-[#7DF9FF]/40 transition-colors">
              <div className="h-28 bg-cover bg-center relative" style={{ backgroundImage: `url(${e.hero_image})` }}>
                <div className="absolute inset-0 bg-gradient-to-t from-[#141417] via-[#141417]/40 to-transparent" />
                <span className="absolute top-2 right-2 text-[11px] font-semibold px-2.5 py-1 rounded-full backdrop-blur" style={{ background: `${LABEL_COLOR[e.overall_label] || "#888"}22`, color: LABEL_COLOR[e.overall_label] || "#ccc", border: `1px solid ${LABEL_COLOR[e.overall_label] || "#888"}66` }}>{e.overall_label}</span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div className="font-display font-bold text-lg">{e.title}</div>
                  <ChevronRight className="h-5 w-5 text-zinc-500" />
                </div>
                <div className="text-xs text-zinc-500 mt-0.5">{e.n_steps} tappe{e.exp_total ? ` · €${Number(e.exp_total).toFixed(2)}` : ""}</div>
                <div className="mt-3 h-2 rounded-full bg-white/10 overflow-hidden">
                  <div className="h-full rounded-full transition-all" style={{ width: `${e.overall_progress}%`, background: LABEL_COLOR[e.overall_label] || "#7DF9FF" }} data-testid={`experience-progress-${e.id}`} />
                </div>
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
